import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Plus, Trash2, Edit2, X } from 'lucide-react';
import { useAuth } from '@/context/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const ROLES = ['manager', 'bond_agent', 'intake_agent', 'auditor'];

const UsersView = () => {
  const { user: me } = useAuth();
  const [users, setUsers] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ email: '', password: '', name: '', role: 'intake_agent' });
  const [error, setError] = useState('');

  const load = () => axios.get(`${API}/users`).then((res) => setUsers(res.data));
  useEffect(() => { load(); }, []);

  const createUser = async (e) => {
    e.preventDefault();
    setError('');
    try {
      await axios.post(`${API}/users`, form);
      setShowForm(false);
      setForm({ email: '', password: '', name: '', role: 'intake_agent' });
      load();
    } catch (err) {
      setError(err?.response?.data?.detail || 'Failed to create user');
    }
  };

  const toggleActive = async (u) => {
    await axios.put(`${API}/users/${u.email}`, { active: !u.active });
    load();
  };

  const deleteUser = async (email) => {
    if (!window.confirm(`Remove ${email}?`)) return;
    await axios.delete(`${API}/users/${email}`);
    load();
  };

  return (
    <div data-testid="dash-users">
      <div className="dash-panel">
        <div className="dash-panel__head">
          <h2>Users &amp; Roles</h2>
          <button className="dash-btn primary" onClick={() => setShowForm(true)} data-testid="add-user-btn"><Plus size={14} /> Add User</button>
        </div>
        <table className="dash-table">
          <thead><tr><th>Name</th><th>Email</th><th>Role</th><th>Status</th><th></th></tr></thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.email} data-testid={`user-row-${u.email}`}>
                <td>{u.name}</td>
                <td>{u.email}</td>
                <td><span className={`role-badge role-${u.role}`}>{u.role.replace('_', ' ')}</span></td>
                <td><span className={`badge ${u.active !== false ? 'badge-success' : 'badge-muted'}`}>{u.active !== false ? 'Active' : 'Inactive'}</span></td>
                <td style={{ display: 'flex', gap: 6 }}>
                  <button className="dash-btn" onClick={() => toggleActive(u)} data-testid={`toggle-active-${u.email}`}><Edit2 size={13} /></button>
                  {u.email !== me.email && <button className="dash-btn danger" onClick={() => deleteUser(u.email)} data-testid={`delete-user-${u.email}`}><Trash2 size={13} /></button>}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {showForm && (
        <div className="modal-overlay" onClick={() => setShowForm(false)}>
          <div className="modal-box" onClick={(e) => e.stopPropagation()}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <h3>Add Staff User</h3>
              <button onClick={() => setShowForm(false)} style={{ background: 'none', border: 'none', color: 'var(--text-muted)', cursor: 'pointer' }}><X size={18} /></button>
            </div>
            <form onSubmit={createUser}>
              <div className="form-field"><label className="form-label">Full Name</label><input required className="form-input" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} data-testid="new-user-name" /></div>
              <div className="form-field"><label className="form-label">Email</label><input required type="email" className="form-input" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="new-user-email" /></div>
              <div className="form-field"><label className="form-label">Password</label><input required type="password" className="form-input" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="new-user-password" /></div>
              <div className="form-field">
                <label className="form-label">Role</label>
                <select className="form-select" value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })} data-testid="new-user-role">
                  {ROLES.map((r) => <option key={r} value={r}>{r.replace('_', ' ')}</option>)}
                </select>
              </div>
              {error && <div className="form-error mb-4">{error}</div>}
              <div className="modal-actions">
                <button type="button" className="dash-btn" onClick={() => setShowForm(false)}>Cancel</button>
                <button type="submit" className="dash-btn primary" data-testid="new-user-submit">Create User</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default UsersView;
